// @flow strict

import type { SegmentAnalytics } from './types';

type Callback = (s: SegmentAnalytics) => void;
type UseSegmentFunction = (cb: Callback) => void;

export const useSegment: UseSegmentFunction = cb => {
  const segment: ?SegmentAnalytics = window.analytics;

  if (!segment) {
    return;
  }

  cb(segment);
};
